(() => {
  if (customElements.get('articles-carousel')) {
    return;
  }

  class ArticlesCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
      this.attachEvents();
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const isMobileDevices = window.matchMedia(
          this.mobileBreakpoint,
        ).matches;

        if (
          (isMobileDevices && this.sliderType === 'mobile') ||
          (!isMobileDevices && this.sliderType === 'desktop')
        ) {
          return;
        }

        this.destroySlider();

        this.initSlider();
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));
    }

    initElements() {
      this.mobileBreakpoint = '(max-width: 749px)';
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
        },
      };
      this.sliderType = '';
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      this.options.centeredSlides = isMobileDevices ? true : false;

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );

      this.sliderType = isMobileDevices ? 'mobile' : 'desktop';
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }
  }

  customElements.define('articles-carousel', ArticlesCarousel);
})();
